/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEmrDocument } from './ExternalEmrDocument';
import {
    ExternalEmrDocumentFromJSON,
    ExternalEmrDocumentFromJSONTyped,
    ExternalEmrDocumentToJSON,
} from './ExternalEmrDocument';

/**
 * 
 * @export
 * @interface ExternalEmrDocumentList
 */
export interface ExternalEmrDocumentList {
    /**
     * True while a pull is in flight for this patient. A failed pull stays true until its DLQ message is redriven and succeeds.
     * @type {boolean}
     * @memberof ExternalEmrDocumentList
     */
    is_pulling: boolean;
    /**
     * When a pull last ran to completion for this patient. Null means one has never finished, which is what distinguishes a patient nobody has collected for from one Net Health returned nothing for.
     * @type {string}
     * @memberof ExternalEmrDocumentList
     */
    documents_pulled_at?: string | null;
    /**
     * 
     * @type {Array<ExternalEmrDocument>}
     * @memberof ExternalEmrDocumentList
     */
    documents: Array<ExternalEmrDocument>;
}

/**
 * Check if a given object implements the ExternalEmrDocumentList interface.
 */
export function instanceOfExternalEmrDocumentList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_pulling" in value;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function ExternalEmrDocumentListFromJSON(json: any): ExternalEmrDocumentList {
    return ExternalEmrDocumentListFromJSONTyped(json, false);
}

export function ExternalEmrDocumentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocumentList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_pulling': json['is_pulling'],
        'documents_pulled_at': !exists(json, 'documents_pulled_at') ? undefined : json['documents_pulled_at'],
        'documents': ((json['documents'] as Array<any>).map(ExternalEmrDocumentFromJSON)),
    };
}

export function ExternalEmrDocumentListToJSON(value?: ExternalEmrDocumentList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_pulling': value.is_pulling,
        'documents_pulled_at': value.documents_pulled_at,
        'documents': ((value.documents as Array<any>).map(ExternalEmrDocumentToJSON)),
    };
}

